import { jsx as _jsx } from "react/jsx-runtime";
import PluginEntrySubInfo from './PackageEntrySubInfo';
import PreferencesSegment from '../../../PreferencesComponents/PreferencesSegment';
const PackageEntry = ({ plugin }) => {
    return (_jsx(PreferencesSegment, { children: _jsx(PluginEntrySubInfo, { plugin: plugin }) }));
};
export default PackageEntry;
